import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { MDBModalRef, MDBModalService } from "ng-uikit-pro-standard";
import { ModalInfoPluginsComponent } from "src/app/portal/components/modal-info-plugins/modal-info-plugins.component";
import { TokenStatus } from "src/app/shared/components/token-input/token-input.component";

import { InvestorType } from "src/app/shared/enum/investor-type.enum";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-etapa-cadastro-email",
  templateUrl: "./etapa-cadastro-email.component.html",
  styleUrls: ["./etapa-cadastro-email.component.scss"],
})
export class EtapaCadastroEmailComponent {
  @Input() etapa: "dados" | "email" = "dados";
  @Input() typeForm: InvestorType;

  @Input() formInvestidorPF: FormGroup;
  @Input() formInvestidorPJ: FormGroup;
  @Input() formResponsavelEntidade: FormGroup;
  @Input() formToken: FormGroup;

  @Input() tableDdi: any[] = [];
  @Input() showPassword: boolean = false;
  @Input() maiorDeIdade: boolean = true;
  @Input() disableButton = "reenviar-codigo";
  @Input() nextDisabled: boolean = false;
  @Input() tokenStatus: TokenStatus = "idle";
  @Input() validating: boolean = false;

  @Output() showPasswordChange = new EventEmitter<boolean>();
  @Output() proximo = new EventEmitter<void>();
  @Output() voltarToken = new EventEmitter<void>();
  @Output() continuarToken = new EventEmitter<void>();
  @Output() reenviarToken = new EventEmitter<void>();

  modalRef: MDBModalRef;

  mostrarSenha = false;
  mostrarConfirmarSenha = false;

  checarSenha = {
    minLength: false,
    uppercase: false,
    specialCharacter: false,
    number: false
  }

  constructor(
    private modalService: MDBModalService,
  ) {}

  togglePassword() {
    this.showPasswordChange.emit(!this.showPassword);
  }

  termoPoliticaPrivacidade() {
    window.open(environment.privacyPolicy);
  }

  //Mask
  maskTelefone(telefone: number) {
    if (this.ddiPF.value == "+55") {
      if (telefone == 1) return "(00) 0000-0000";
      else return "(00) 0 0000-0000";
    } else return "000000000000000";
  }

  checkSenha() {
    const senhaPJ = this.formInvestidorPJ.get('senha')?.value || '';
    const senhaPF = this.formInvestidorPF.get('senha')?.value || '';

    const senha = senhaPJ || senhaPF;

    this.checarSenha = {
      minLength: senha.length >= 8,
      uppercase: /[A-Z]/.test(senha),
      specialCharacter: /[^A-Za-z0-9]/.test(senha),
      number: /\d/.test(senha)
    }
  }

  statusSenha() {
    this.checarSenha = {
      minLength: false,
      uppercase: false,
      specialCharacter: false,
      number: false
    }
  }

  openModalInfo() {
    let config = {
      scroll: true,
      ignoreBackDropClick: true,
    }

    this.modalRef = this.modalService.show(ModalInfoPluginsComponent, config)
  }

  get emailUsuario(): string {
    switch (this.typeForm) {
      case InvestorType.PF:
        return this.formInvestidorPF?.get("email")?.value ?? '';
      case InvestorType.PJ:
      case InvestorType.Investment:
        return this.formInvestidorPJ?.get("email")?.value ?? '';
      case InvestorType.Entity:
        return this.formResponsavelEntidade?.get("email")?.value ?? '';
      default:
        return '';
    }
  }

  // Get & Setter Global
  get token() {
    return this.formToken.get("token");
  }

  // Get & Setter PJ
  get nomePJ() {
    return this.formInvestidorPJ.get("nome");
  }

  get documentoIdentificadorPJ() {
    return this.formInvestidorPJ.get("documentoIdentificador");
  }

  get emailPJ() {
    return this.formInvestidorPJ.get("email");
  }

  get dataNascimentoPJ() {
    return this.formInvestidorPJ.get("dataNascimento");
  }

  get confirmaEmailPJ() {
    return this.formInvestidorPJ.get("confirmaEmail");
  }

  get senhaPJ() {
    return this.formInvestidorPJ.get("senha");
  }

  get confirmarSenhaPJ() {
    return this.formInvestidorPJ.get("confirmaSenha");
  }

  get termPJ() {
    return this.formInvestidorPJ.get("termoAceite");
  }

  // Get & Setter Entidade (Dados Responsável)
  get documentoIdentificadorResponsavelEntidade() {
    return this.formResponsavelEntidade.get("documentoIdentificador");
  }

  get nomeContatoResponsavelEntidade() {
    return this.formResponsavelEntidade.get("nomeContato");
  }

  get emailResponsavelEntidade() {
    return this.formResponsavelEntidade.get("email");
  }

  get confirmaEmailResponsavelEntidade() {
    return this.formResponsavelEntidade.get("confirmaEmail");
  }

  get senhaResponsavelEntidade() {
    return this.formResponsavelEntidade.get("senha");
  }

  get confirmarSenhaResponsavelEntidade() {
    return this.formResponsavelEntidade.get("confirmaSenha");
  }

  get termResponsavelEntidade() {
    return this.formResponsavelEntidade.get("termoAceite");
  }

  get dataNascimentoEntidade() {
    return this.formResponsavelEntidade.get("dataNascimento");
  }

  // Get & Setter PF
  get documentoIdentificadorPF() {
    return this.formInvestidorPF.get("documentoIdentificador");
  }

  get nomePF() {
    return this.formInvestidorPF.get("nome");
  }

  get emailPF() {
    return this.formInvestidorPF.get("email");
  }

  get confirmaEmailPF() {
    return this.formInvestidorPF.get("confirmaEmail");
  }

  get ddiPF() {
    return this.formInvestidorPF.get("codigoDdi");
  }

  get telefonePF() {
    return this.formInvestidorPF.get("telefone");
  }

  get celularPF() {
    return this.formInvestidorPF.get("celular");
  }

  get dataNascimentoPF() {
    return this.formInvestidorPF.get("dataNascimento");
  }

  get incapazPF() {
    return this.formInvestidorPF.get("incapaz");
  }

  get documentoResponsavelPF() {
    return this.formInvestidorPF.get("documentoResponsavel");
  }

  get nomeResponsavelPF() {
    return this.formInvestidorPF.get("nomeResponsavel");
  }

  get senhaPF() {
    return this.formInvestidorPF.get("senha");
  }

  get confirmarSenhaPF() {
    return this.formInvestidorPF.get("confirmaSenha");
  }

  get termPF() {
    return this.formInvestidorPF.get("termoAceite");
  }
}
